/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_ActivateInputs */

const cs_sreality_activate = /** @type {(inputs: Sreality_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit export`)
};

const en_sreality_activate = /** @type {(inputs: Sreality_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume export`)
};

/**
* | output |
* | --- |
* | "Resume export" |
*
* @param {Sreality_ActivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_activate = /** @type {((inputs?: Sreality_ActivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_ActivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_activate(inputs)
	return cs_sreality_activate(inputs)
});